(function(){
  function init(el){
    var body = el.querySelector('.clampy-body');
    var btn = el.querySelector('.clampy-btn');
    if(!body || !btn) return;
    function check(){
      if(el.classList.contains('open')) return;
      var more = body.scrollHeight > body.clientHeight + 6;
      btn.hidden = !more;
      el.classList.toggle('has-more', more);
    }
    btn.addEventListener('click', function(){
      var open = el.classList.toggle('open');
      btn.textContent = open ? (btn.getAttribute('data-less') || 'Lees minder') : (btn.getAttribute('data-more') || 'Lees meer');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if(!open){
        check();
        var top = el.getBoundingClientRect().top;
        if(top < 0) window.scrollTo({ top: top + window.scrollY - 100, behavior: 'smooth' });
      }
    });
    check();
    var t; window.addEventListener('resize', function(){ clearTimeout(t); t = setTimeout(check, 150); });
  }
  function boot(){ [].slice.call(document.querySelectorAll('[data-clamp]')).forEach(init); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();
